<template>

  <v-app id="wgu-app" data-app :class="{ 'wgu-app': true }">

    <!-- Permanent Navigation Drawer -->
    <v-navigation-drawer v-if="showSidebar" app permanent :mini-variant="drawerMini" width="160" color="primary">
      <div class="d-flex align-center px-3" style="height: 64px;">
        <v-app-bar-nav-icon @click.stop="drawerMini = !drawerMini" color="white"></v-app-bar-nav-icon>
        <span v-if="!drawerMini" class="text-h6 white--text ml-2 font-weight-bold text-truncate">公升大格</span>
      </div>

      <v-list dense nav class="mt-2">
        <v-list-item v-for="(item, i) in mainMenuItems" :key="i" link :to="item.path" @click="handleMenuClick(item)"
          class="mb-1 white--text" active-class="white--text v-list-item--active-custom">
          <v-list-item-icon>
            <v-icon color="white">{{ item.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="font-weight-medium">{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <slot name="wgu-app-begin" />

    <wgu-app-header v-if="showGlobalHeader">
      <!-- forward the slots of AppHeader -->
      <template v-slot:wgu-tb-start>
        <slot name="wgu-tb-start" />
      </template>
      <template v-slot:wgu-tb-after-title>
        <slot name="wgu-tb-after-title" />
      </template>
      <template v-slot:wgu-tb-before-auto-buttons>
        <slot name="wgu-tb-before-auto-buttons" />
      </template>
      <template v-slot:wgu-tb-after-auto-buttons>
        <slot name="wgu-tb-after-auto-buttons" />
      </template>
      <template v-slot:wgu-tb-end>
        <slot name="wgu-tb-end" />
      </template>
    </wgu-app-header>

    <slot name="wgu-after-header" />

    <wgu-app-sidebar v-if="sidebarWins.length" v-bind="sidebarConfig">
      <template v-for="(moduleWin, index) in sidebarWins">
        <component :is="moduleWin.type" :key="index" v-bind="moduleWin" />
      </template>
    </wgu-app-sidebar>

    <slot name="wgu-before-content" />
    <v-main app>
      <div id="ol-map-container" class="fill-height" v-if="isMapRoute">
        <wgu-map />
        <wgu-maploading-status />
        <wgu-app-logo />
        <wgu-bglayerswitcher />
        <wgu-overviewmap v-if="overviewMapConfig" v-bind="overviewMapConfig" />
        <wgu-hover-tooltip />
        <ks-popup-tooltip />
      </div>

      <div v-if="!isMapRoute" class="fill-height white d-flex flex-column w-100">
        <router-view></router-view>
      </div>
    </v-main>

    <template v-for="(moduleWin, index) in filteredFloatingWins">
      <component :is="moduleWin.type" :key="index" v-bind="moduleWin" />
    </template>

    <slot name="wgu-before-footer" />

    <wgu-app-footer v-if="showGlobalFooter" :footerTextLeft="$t('app.footerTextLeft')" :footerTextRight="$t('app.footerTextRight')"
      :showCopyrightYear="showCopyrightYear" />

    <slot name="wgu-after-footer" />
    <v-overlay :z-index="zIndex" :value="overlay" @click="handleClose" class="custom-overlay">
      <div class="parent">
        <img :src="image" style="height: 88%; position: relative; top: 30px;" @click="handleClose" />
      </div>
    </v-overlay>

    <!-- app wide loading mask,
    use WguEventBus.$emit('app-loading-mask-toggle', newViz) to show/hide -->
    <wgu-app-loading-mask />

    <slot name="wgu-app-end" />
  </v-app>
</template>

<script>
import Vue from 'vue'
import { WguEventBus } from './WguEventBus'
import OlMap from './components/ol/Map'
import HoverTooltip from './components/ol/HoverTooltip'
import PopUpTooltip from './components/ol/PopUpTooltip'
import AppHeader from './app-components/AppHeader'
import AppFooter from './app-components/AppFooter'
import AppSidebar from './app-components/AppSidebar'
import AppLogo from './components/AppLogo'
import AppLoadingMask from './components/AppLoadingMask'
import BgLayerSwitcher from './components/bglayerswitcher/BgLayerSwitcher.vue'
import OverviewMap from './components/overviewmap/OverviewMap.vue'
import MeasureWin from './components/measuretool/MeasureWin'
import LayerListWin from './components/layerlist/LayerListWin'
import HelpWin from './components/helpwin/HelpWin'
import InfoClickWin from './components/infoclick/InfoClickWin'
import MapLoadingStatus from './components/progress/MapLoadingStatus'
import AttributeTableWin from './components/attributeTable/AttributeTableWin.vue'
import MapRecorderWin from './components/maprecorder/MapRecorderWin'
import SampleModuleWin from './app-components/SampleModule.vue'
import InsureWin from '@/components/insuretool/InsureWin.vue'
import DisasterTableWin from './components/disasterTable/DisasterTableWin.vue'
import AssessWin from './components/assesstool/assessWin.vue'
import InsuranceTableWin from './components/insuranceTable/InsuranceTableWin.vue'
import PolicyWin from '@/components/policytool/PolicyWin.vue'
import DataImportWin from './components/Import/DataImport.vue'
import StatsPanelWin from './components/dashboard/StatsPanel.vue'
import AutoLocateArea from './mixins/AutoLocateArea'
import { PLOT_WMS_URL, PLOT_WMS_LAYER } from '@/const/const.js'
import { menusForRole } from '@/const/menus'

export default {
  name: 'app-layout',
  mixins: [AutoLocateArea],
  components: {
    'ks-data-import-win': DataImportWin,
    'ks-stats-win': StatsPanelWin,
    'wgu-map': OlMap,
    'wgu-hover-tooltip': HoverTooltip,
    'wgu-app-header': AppHeader,
    'wgu-app-footer': AppFooter,
    'wgu-app-sidebar': AppSidebar,
    'wgu-app-logo': AppLogo,
    'wgu-app-loading-mask': AppLoadingMask,
    'wgu-bglayerswitcher': BgLayerSwitcher,
    'wgu-overviewmap': OverviewMap,
    'wgu-measuretool-win': MeasureWin,
    'wgu-layerlist-win': LayerListWin,
    'wgu-helpwin-win': HelpWin,
    'wgu-infoclick-win': InfoClickWin,
    'wgu-maploading-status': MapLoadingStatus,
    'wgu-attributetable-win': AttributeTableWin,
    'wgu-maprecorder-win': MapRecorderWin,
    'sample-module-win': SampleModuleWin,
    'wgu-insuretool-win': InsureWin,
    'ks-disastertable-win': DisasterTableWin,
    'ks-popup-tooltip': PopUpTooltip,
    'ks-assessclick-win': AssessWin,
    'ks-insurancetable-win': InsuranceTableWin,
    'ks-policytool-win': PolicyWin
  },
  data () {
    // 首页模块配置（原 app-conf.json 的 modules 部分）
    const moduleConfig = {
      'wgu-layerlist': {
        target: 'menu',
        win: 'floating',
        icon: 'layers',
        draggable: false
      },
      'wgu-measuretool': {
        target: 'menu',
        win: 'floating',
        icon: 'photo_size_select_small',
        draggable: false,
        strokeColor: '#c62828',
        fillColor: 'rgba(198,40,40,0.2)',
        sketchStrokeColor: 'rgba(198,40,40,0.8)',
        sketchFillColor: 'rgba(198,40,40,0.1)',
        sketchVertexStrokeColor: '#c62828',
        sketchVertexFillColor: 'rgba(198,40,40,0.2)'
      },
      'wgu-insuretool': {
        target: 'menu',
        win: 'floating',
        icon: 'playlist_add_check',
        draggable: false,
        strokeColor: '#c62828',
        fillColor: 'rgba(198,40,40,0.2)',
        sketchStrokeColor: 'rgba(198,40,40,0.8)',
        sketchFillColor: 'rgba(198,40,40,0.1)',
        sketchVertexStrokeColor: '#c62828',
        sketchVertexFillColor: 'rgba(198,40,40,0.2)'
      },
      'ks-policytool': {
        target: 'menu',
        win: 'floating',
        icon: 'policy',
        draggable: false,
        strokeColor: '#c62828',
        fillColor: 'rgba(198,40,40,0.2)',
        sketchStrokeColor: 'rgba(198,40,40,0.8)',
        sketchFillColor: 'rgba(198,40,40,0.1)',
        sketchVertexStrokeColor: '#c62828',
        sketchVertexFillColor: 'rgba(198,40,40,0.2)'
      },
      'ks-assessclick': {
        target: 'menu',
        win: 'floating',
        icon: 'mdi-clipboard-check',
        draggable: false,
        strokeColor: '#c62828',
        fillColor: 'rgba(198,40,40,0.2)',
        sketchStrokeColor: 'rgba(198,40,40,0.8)',
        sketchFillColor: 'rgba(198,40,40,0.1)',
        sketchVertexStrokeColor: '#c62828',
        sketchVertexFillColor: 'rgba(198,40,40,0.2)'
      },
      'wgu-geocoder': {
        target: 'toolbar',
        minChars: 2,
        queryDelay: 200,
        debug: false,
        provider: 'osm',
        providerOptions: {
          lang: 'en-US',
          countrycodes: '',
          limit: 6
        }
      },
      'wgu-zoomtomaxextent': {
        target: 'toolbar'
      },
      'wgu-geolocator': {
        target: 'toolbar'
      },
      'wgu-themeswitcher': {
        target: 'toolbar',
        icon: 'dark_mode'
      },
      'wgu-attributetable': {
        target: 'menu',
        win: 'floating',
        icon: 'list_alt',
        syncTableMapSelection: true
      },
      'ks-insurancetable': {
        target: 'menu',
        win: 'floating',
        icon: 'table_chart',
        syncTableMapSelection: true
      },
      'ks-disastertable': {
        target: 'menu',
        win: 'floating',
        icon: 'broken_image',
        syncTableMapSelection: true
      },
      'ks-stats': {
        target: 'menu',
        win: 'floating',
        icon: 'mdi-chart-bar'
      }
    };

    // 首页地图图层配置
    const mapLayersConfig = [
      {
        type: 'IMAGEWMS',
        lid: 'region-layer',
        name: '行政区划',
        ratio: 1.5,
        format: 'image/png',
        layers: 'ks:geo_district_code',
        url: 'https://geo.kungsong.com/geoserver/ks/wms',
        transparent: true,
        projection: 'EPSG:4326',
        attribution: 'provided by kungsong.com',
        isBaseLayer: false,
        visible: true,
        displayInLayerList: true,
        opacityControl: true,
        crossOrigin: 'anonymous'
      },
      {
        type: 'IMAGEWMS',
        lid: 'wms-plot-layer',
        name: '地块信息 (WMS)',
        url: PLOT_WMS_URL,
        layers: PLOT_WMS_LAYER,
        format: 'image/png',
        transparent: true,
        projection: 'EPSG:4326',
        visible: true,
        isBaseLayer: false,
        displayInLayerList: true,
        opacityControl: true,
        crossOrigin: 'anonymous'
      },
      {
        type: 'VECTOR',
        lid: 'insured-plots-layer',
        name: '已投保地块',
        url: 'plots/?bs=1',
        format: 'GeoJSON',
        visible: true,
        selectable: true,
        hoverable: true,
        hoverAttribute: 'qsrmc',
        displayInLayerList: true,
        opacity: 0.8,
        style: {
          strokeColor: '#1976D2',
          strokeWidth: 2,
          fillColor: 'rgba(25, 118, 210, 0.3)'
        },
        selectStyle: {
          strokeColor: '#d32f2f',
          strokeWidth: 3,
          fillColor: 'rgba(211, 47, 47, 0.4)'
        }
      },
      {
        type: 'VECTOR',
        lid: 'uninsured-plots-layer',
        name: '未投保地块',
        url: 'plots/?bs=0',
        format: 'GeoJSON',
        visible: true,
        selectable: true,
        hoverable: true,
        hoverAttribute: 'qsrmc',
        displayInLayerList: true,
        opacity: 0.6,
        style: {
          strokeColor: '#FFA726',
          strokeWidth: 2,
          fillColor: 'rgba(255, 167, 38, 0.2)'
        },
        selectStyle: {
          strokeColor: '#d32f2f',
          strokeWidth: 3,
          fillColor: 'rgba(211, 47, 47, 0.4)'
        }
      },
      {
        type: 'VECTOR',
        lid: 'plot-boundaries-layer',
        name: '地块边界',
        url: 'plots/',
        format: 'GeoJSON',
        visible: true,
        selectable: false,
        hoverable: false,
        displayInLayerList: true,
        opacity: 1.0,
        style: {
          strokeColor: '#388E3C',
          strokeWidth: 1,
          fillColor: 'rgba(0, 0, 0, 0)'
        }
      },
      {
        type: 'XYZ',
        url: 'https://t4.tianditu.gov.cn/DataServer?T=cia_w&tk=2d986e569889fd35b5587da2ce9574b7&x={x}&y={y}&l={z}',
        lid: 'satelliteMark',
        name: '天地图标注',
        isBaseLayer: false,
        visible: true,
        crossOrigin: 'anonymous'
      },
      {
        type: 'XYZ',
        url: 'https://t6.tianditu.gov.cn/DataServer?T=img_w&x={x}&y={y}&l={z}&tk=2d986e569889fd35b5587da2ce9574b7',
        lid: 'satelliteBackground',
        name: '天地图卫星',
        isBaseLayer: true,
        visible: true,
        crossOrigin: 'anonymous'
      },
      {
        type: 'OSM',
        lid: 'osm-bg',
        name: 'OpenStreetMap',
        isBaseLayer: true,
        visible: false,
        crossOrigin: 'anonymous'
      }
    ];

    return {
      isEmbedded: false,
      moduleConfig,
      mapLayersConfig,
      sidebarConfig: this.getSidebarConfig(),
      overviewMapConfig: this.getOverviewMapConfig(),
      floatingWins: this.getModuleWinData('floating', moduleConfig),
      sidebarWins: this.getModuleWinData('sidebar', moduleConfig),
      showCopyrightYear: Vue.prototype.$appConfig.showCopyrightYear,
      zIndex: 9999,
      overlay: false,
      image: '',
      drawerMini: false
    }
  },
  created () {
    // **关键修复**：在 created 钩子中注入配置，确保子组件（如 AppHeader）初始化时能读取到
    Vue.prototype.$appConfig.mapLayers = this.mapLayersConfig;
    Vue.prototype.$appConfig.modules = this.moduleConfig;

    this.setDocumentTitle();
    const moduleName = 'ks-image-box';
    console.log('created', moduleName);
    WguEventBus.$on(moduleName + '-visibility-change', ({ visible, imageIndex }) => {
      this.overlay = visible;
      this.image = imageIndex;
      console.log('visibility-change', visible, imageIndex);
    });
    // Initialize and load codes data
    this.initializeCodes();
  },
  mounted () {
    this.isEmbedded = this.$isEmbedded;
    const refs = this.$refs;
    const cmpLookup = {};
    for (const key of Object.keys(refs)) {
      cmpLookup[key] = refs[key][0];
    }
    Vue.prototype.cmpLookup = cmpLookup;

    WguEventBus.$emit('app-mounted');

    // 监听地图挂载事件，自动定位到已选区域
    this._onMapMounted = (map) => {
      console.log('Map mounted in AppLayout');
      setTimeout(() => {
        this.autoLocateToSelectedArea();
      }, 500);
    };

    WguEventBus.$on('ol-map-mounted', this._onMapMounted);
  },
  beforeDestroy () {
    if (this._onMapMounted) {
      WguEventBus.$off('ol-map-mounted', this._onMapMounted);
      this._onMapMounted = null;
    }
  },
  computed: {
    mainMenuItems () {
      return menusForRole(this.$store.state.user?.role)
    },
    isImmersiveRoute () {
      return ['Dashboard', 'InsuranceResults', 'ReportPlatform',
        'InsurancePolicyCropReport', 'InsurancePlotAreaReport',
        'InsuranceUnderwritingStatReport', 'Claim'].includes(this.$route.name)
    },
    isMapRoute () {
      return false;
    },
    filteredFloatingWins () {
      if (!this.floatingWins) return []
      const hideStatsRoutes = ['Home', 'InsureApply', 'PolicyList', 'PolicyEdit', 'PolicyPlotDetails', 'InsuranceResults', 'Dashboard', 'ReportPlatform', 'InsurancePolicyCropReport', 'InsurancePlotAreaReport', 'InsuranceUnderwritingStatReport', 'Claim']
      if (hideStatsRoutes.includes(this.$route.name)) {
        return this.floatingWins.filter(win => win.type !== 'ks-stats-win')
      }
      return this.floatingWins
    },
    showSidebar () {
      return !this.isImmersiveRoute
    },
    showGlobalHeader () {
      return !this.isImmersiveRoute
    },
    showGlobalFooter () {
      return !this.isImmersiveRoute
    }
  },
  methods: {
    handleMenuClick (item) {
      if (item.path) {
        const mapPages = ['/ins', '/insure-apply']
        const isMapPage = mapPages.includes(item.path)

        // If we are navigating to the same path, re-run map locate for map-related pages
        if (this.$route.path === item.path) {
          if (isMapPage) {
            this.$nextTick(() => {
              if (this.$map) {
                this.$map.updateSize()
              }
              // Trigger auto-locate for the current view
              // The view's own AutoLocateArea mixin will handle the location
              WguEventBus.$emit('trigger-map-locate')
            })
          }
        } else {
          // Navigate to different path
          this.$router.push(item.path).then(() => {
            // After navigation, trigger map locate for map pages
            if (isMapPage) {
              this.$nextTick(() => {
                if (this.$map) {
                  this.$map.updateSize()
                }
                WguEventBus.$emit('trigger-map-locate')
              })
            }
          })
        }
      } else if (item.moduleName) {
        WguEventBus.$emit(item.moduleName + '-visibility-change', true)
      } else if (item.action === 'showMap') {
        if (this.$route.path !== '/ins') {
          this.$router.push('/ins')
        }
      }
    },
    getSidebarConfig () {
      const appConfig = Vue.prototype.$appConfig || {};
      return appConfig.sidebar;
    },
    getOverviewMapConfig () {
      const appConfig = Vue.prototype.$appConfig || {};
      return appConfig.overviewMap;
    },
    getModuleWinData (target, modulesConf) {
      // 使用传入的模块配置，而不是从 $appConfig 读取
      const modulesConfs = modulesConf || {};
      const moduleWins = [];
      console.log('Available modules:', Object.keys(modulesConfs)); // 调试可用模块
      for (const key of Object.keys(modulesConfs)) {
        const moduleOpts = modulesConfs[key];
        if (moduleOpts.win === target) {
          moduleWins.push({
            type: key + '-win',
            ...moduleOpts
          });
        }
      }
      console.log('Module wins for', target, ':', moduleWins); // 调试模块窗口数据
      return moduleWins;
    },
    setDocumentTitle () {
      document.title = this.$t('app.browserTitle') || document.title;
    },
    handleClose () {
      const moduleName = 'ks-image-box';
      WguEventBus.$emit(moduleName + '-visibility-change', { visible: false, imageIndex: 0 });
    },
    // Add new method to initialize codes
    async initializeCodes () {
      // Define code types that need to be loaded
      const codeTypes = ['CROP', 'picc', 'ahic'];

      try {
        // Load all code types in parallel
        const promises = codeTypes.map(type => this.$store.dispatch('queryCodes', type));
        await Promise.all(promises);
        console.log('All codes loaded successfully');
      } catch (error) {
        console.error('Error initializing codes:', error);
      }
    }
  },
  watch: {
    '$i18n.locale': function () {
      this.setDocumentTitle();
    }
  }
}
</script>
<style scoped>
#popup-content {
  display: flex;
  justify-content: space-between;
  /* 根据需要调整 */
}

.parent {
  display: flex;
  height: 100vh;
  /* 例如，使父组件高度为视口高度的100% */
}

.custom-overlay {
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
}

.panel-toggle-btn {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 1;
  background-color: white !important;
}

>>>.v-main__wrap {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
}
</style>
